import React, { Component, ReactNode } from 'react'

import { Container } from 'modules/flex-layout'

import './layout.scss'

type Props = {
  children: {
    aside: ReactNode
    body: ReactNode
  }
}
export class Layout extends Component<Props> {
  render() {
    const { children } = this.props

    return (
      <>
        <aside data-test="aside">{children.aside}</aside>
        <Container fluid data-test="content" tag="main">
          {children.body}
        </Container>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout.tsx